import { httpClient } from '@/core/api/httpClient';
import { API_V1 } from '@/core/api/endpoints';
import { toPascalCaseParams } from '@/shared/lib/to-pascal-case-params';
import { env } from '@/core/config/env';
import { mockMyTasks, mockMyOverdueTasks, mockMyTimeAnalysis } from './personal-summary.mock';
import type {
  MyTasksParams,
  MyOverdueTasksParams,
  MyTimeAnalysisParams,
  MyTaskPagedResult,
  MyOverdueTaskPagedResult,
  MyTimeAnalysisDto,
} from '../types';

const USE_MOCK = env.VITE_USE_MOCK === 'true';

// Personal Summary is cross-tenant (user-scoped, spans every org/project) — every
// call opts out of X-Tenant-Id, same pattern as Notes.
const NO_TENANT = { skipTenantHeader: true } as const;

export const personalSummaryService = {
  getMyTasks: async (params?: MyTasksParams, signal?: AbortSignal): Promise<MyTaskPagedResult> => {
    if (USE_MOCK) return mockMyTasks;
    const { data } = await httpClient.get<MyTaskPagedResult>(`${API_V1}/me/summary/tasks`, {
      ...NO_TENANT,
      params: params ? toPascalCaseParams(params as Record<string, unknown>) : undefined,
      signal,
    });
    return data;
  },

  getMyOverdueTasks: async (
    params?: MyOverdueTasksParams,
    signal?: AbortSignal,
  ): Promise<MyOverdueTaskPagedResult> => {
    if (USE_MOCK) return mockMyOverdueTasks;
    const { data } = await httpClient.get<MyOverdueTaskPagedResult>(
      `${API_V1}/me/summary/overdue-tasks`,
      {
        ...NO_TENANT,
        params: params ? toPascalCaseParams(params as Record<string, unknown>) : undefined,
        signal,
      },
    );
    return data;
  },

  getMyTimeAnalysis: async (
    params?: MyTimeAnalysisParams,
    signal?: AbortSignal,
  ): Promise<MyTimeAnalysisDto> => {
    if (USE_MOCK) return mockMyTimeAnalysis;
    const { data } = await httpClient.get<MyTimeAnalysisDto>(`${API_V1}/me/summary/time-analysis`, {
      ...NO_TENANT,
      params: params ? toPascalCaseParams(params as Record<string, unknown>) : undefined,
      signal,
    });
    return data;
  },
};
